import idx from 'idx'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { required } from 'utils/validation'
import { compose, lifecycle, withHandlers } from 'recompose'
import withMixpanel, { INVITE_CODE_CREATED } from 'utils/mixpanel'
import {FORM_ACTION_ERROR_STATUS, FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS} from 'constants/form'

import * as organisationModule from 'modules/organisation'
import { addDays } from 'date-fns'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected),
        apiCallError: idx(state, _ => _.progress.createCode.hasError) || false,
        errorMessage: idx(state, _ => _.progress.login.createCode.message) || null,
      }
    },
    (dispatch) => {
      const actions = {
        ...organisationModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withFormik({
  // Transform outer props into form values
    mapPropsToValues: () => ({ expiryDate: 7 }),
    // Add a custom validation function (this can be async too!)
    validate: ({ expiryDate }) => {
      const errors = {}
      if (required(expiryDate)) {
        errors.expiryDate = 'Please give an expiry date'
      }
      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      // If form has no error
      const { actions, organisation, track } = props
      if (actions.createOrganisationCode && organisation) {
        const date = values.expiryDate > 0 ? addDays(new Date(), values.expiryDate) : null
        actions.createOrganisationCode(organisation, date, () => {
          track(INVITE_CODE_CREATED)
        })
      }
    },
  }),
  // Handlers
  withHandlers({
    handleFieldChange: props => (event) => {
      // test
      props.setStatus(FORM_PROGRESS_STATUS)
      props.setFieldValue('expiryDate', event.target.value)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
  
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },
  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/OrganisationCodeForm/OrganisationCodeForm.enhancer.js